import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Session } from './utils/session';

export default function Sidebar() {
  const navigate = useNavigate();

  const role = Session.getRole();
  const isSuperAdmin = role === "Super Admin";
  const isAdmin = role === "Admin";
  const isTeamLeader = role === "Team Leader";

  const handleLogout = () => {
    Session.clear();
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
  };

  return (
    <nav id="sidebar">
      <div className="content-box position-relative z-2 px-5">
        <span className='logo_text_monitoing'>
          <img src="/images/avec.png" className="imgFluid_logo" alt="Logo" />
          <h3 className="sidebar-title" style={{ marginTop: '15px', }}>Monitoring</h3>
        </span>
      </div>

      {isSuperAdmin && (
        <>
          {/* Analyze */}
          <p className="sidebar-group-title">Analyze</p>
          <ul className="components">
            <li>
              <NavLink to="/dashboard">
                <i className="fa-solid fa-border-all" /> Dashboard
              </NavLink>
            </li>
          </ul>
          <ul className="components">
            <li>
              <NavLink to="/dailytask">
                <i className="fa-solid fa-list-check" /> Task
              </NavLink>
            </li>
          </ul>

          <ul className="components">
            <li>
              <NavLink to="/StartStopActivity">
                <i className="fa-solid fa-list-check" /> Task Reports
              </NavLink>
            </li>
          </ul>
          {/* Admin */}
          {/* <p className="sidebar-group-title">Admin</p>
          <ul className="components">
            <li>
              <NavLink to="/members">
                <i className="fa-regular fa-user" /> Members
              </NavLink>
            </li>
          </ul> */}

          {/* <p className="sidebar-group-title">Admin</p> */}
          <ul className="components">
            {(isSuperAdmin || isAdmin) && (
              <li>
                <NavLink to="/teams">
                  <i className="fa-solid fa-users" /> Teams
                </NavLink>
              </li>
            )}
            {(isSuperAdmin || isAdmin || isTeamLeader) && (
              <li>
                <NavLink to="/members">
                  <i className="fa-regular fa-user" /> Members
                </NavLink>
              </li>
            )}
          </ul>

          {/* Error Logs */}
          {/* <ul className="components">
            <li>
              <NavLink to="/ErrorLogs">
                <i className="fas fa-exclamation-circle me-1"></i> Error Logs
              </NavLink>
            </li>
          </ul> */}
        </>
      )}

       {/* <ul className="components">
            <li>
               <NavLink to="/dailytask"> 
                <i className="fa-solid fa-list-check" /> Task
                </NavLink>
             
            </li>
          </ul> */}

      {/* ================= LOGOUT (ALL USERS) ================= */}
      <ul className="components">
        <li onClick={handleLogout}>
          <NavLink to="#/">
            <i className="fa-solid fa-right-from-bracket" /> LogOut
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}
